import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  // NavigationCancel,
  RouterStateSnapshot,
} from '@angular/router';
// import { AuthenticationService } from 'app/_services/authentication/authentication.service';
// import * as Sentry from '@sentry/browser';
// import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(protected router: Router, private auth: AngularFireAuth) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log('AuthGuard canActivate: checking if user is logged in');
    if (this.auth.user) {
      console.log('AuthGuard canActivate: user is logged in');
      // userLoggedIn in so return true
      return true;
    }
    console.log('AuthGuard canActivate: user is not logged in');

    // not userLoggedIn in so redirect to login page with the return url
    // Sentry.captureMessage('Error on auth guard', Sentry.Severity.Error);
    this.router.navigate(['/auth/login'], { queryParams: { next: state.url } });
    return false;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.auth.user) {
      // userLoggedIn in so return true
      return true;
    }

    // not userLoggedIn in so redirect to login page with the return url
    // Sentry.captureMessage('Error on auth guard', Sentry.Severity.Error);
    this.router.navigate(['/auth/login'], {
      queryParams: { next: state.url },
    });
    return false;
  }

  canMatch(route: Route, state: RouterStateSnapshot): boolean {
    if (this.auth.user) {
      // userLoggedIn in so return true
      console.log('AuthGuard canMatch: user is logged in');
      return true;
    }
    console.log('AuthGuard canMatch: user NOT is logged in');

    // not userLoggedIn in so redirect to login page with the return url
    // Sentry.captureMessage('Error on auth guard', Sentry.Severity.Error);
    // this.router.navigate(['/auth/login'], { queryParams: { next: state.url } });
    // this.router.events
    //   .pipe(first((_) => _ instanceof NavigationCancel))
    //   .subscribe((event: NavigationCancel) => {
    //     this.router.navigate(['/auth/login'], {
    //       queryParams: {
    //         next: event.url,
    //       },
    //     });
    //   });
    // return new RedirectCommand(urlTree, { skipLocationChange: true });
    // return false;
    this.router.navigate(['/auth/login'], {
      queryParams: { next: state.url },
    });
    return false;
  }
}
